<script setup lang="ts">
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { confirmState, settleConfirm } from '../composables/useConfirm';

const confirmBtn = ref<HTMLButtonElement | null>(null);

function onKey(e: KeyboardEvent) {
  if (!confirmState.open) return;
  if (e.key === 'Escape') { e.preventDefault(); settleConfirm(false); }
  else if (e.key === 'Enter') {
    // 焦点在按钮上时交给按钮自身处理, 避免在 "取消" 上按回车却执行了确认
    if ((e.target as HTMLElement | null)?.tagName === 'BUTTON') return;
    e.preventDefault();
    settleConfirm(true);
  }
}

watch(() => confirmState.open, async (open) => {
  if (open) { await nextTick(); confirmBtn.value?.focus(); }
});

onMounted(() => window.addEventListener('keydown', onKey));
onBeforeUnmount(() => window.removeEventListener('keydown', onKey));
</script>

<template>
  <div v-if="confirmState.open" class="wb-modal-mask" @click.self="settleConfirm(false)">
    <div class="wb-modal" style="--modal-w: 400px" role="alertdialog" aria-modal="true" :aria-label="confirmState.options.title">
      <div class="wb-modal-head">
        <h3>{{ confirmState.options.title }}</h3>
      </div>
      <div v-if="confirmState.options.message" class="wb-modal-body msg">{{ confirmState.options.message }}</div>
      <div class="wb-modal-foot">
        <button class="btn btn-outline" type="button" @click="settleConfirm(false)">
          {{ confirmState.options.cancelText || '取消' }}
        </button>
        <button
          ref="confirmBtn"
          :class="['btn', confirmState.options.danger ? 'btn-danger' : 'btn-primary']"
          type="button"
          @click="settleConfirm(true)"
        >
          {{ confirmState.options.confirmText || '确定' }}
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.msg { white-space: pre-line; }
</style>
